<template lang="pug">
  v-container#side(fluid).pl-0
    v-navigation-drawer(class="lighten-3" light mobile-break-point="1100")
      v-list-item(active-class="test" v-for="section in allSections" :key="section.title" @click="$vuetify.goTo(section.go)")
        v-list-item-content
          v-list-item-title.light-text.bold {{ section.title }}

</template>
<script>
export default {
  name: "Side",
  props: {},
  data() {
    return {
      sections: [
        {
          title: "Postal",
          go: "#top"
        },
        {
          title: "Relatoria / Resumen Ejecutivo",
          go: "#narrative-summary"
        },
        {
          title: "Ubicación en el mapa",
          go: "#location"
        }
      ]
    };
  },
  computed: {
    allSections() {
      let edit = this.$store.state.editing;
      if (edit)
        this.sections.push({
          title: "Historial de actualizaciones",
          go: "#updates"
        });
      return this.sections;
    }
  }
};
</script>
<style scoped lang="scss">
.text {
  background-color: yellow;
}
#side {
  position: fixed;
  max-width: 15vw;
  .navigation-drawer {
    width: 13% !important;
    overflow-wrap: normal;
    width: 100% !important;
    .list:first-child {
      margin-right: 15px;
    }
    & >>> .v-list-item--link {
      padding-left: 30px !important;
      margin: 17px 0;
    }
    .v-list-item__content {
      overflow: visible !important;
      .v-list-item__title {
        overflow: visible !important;
        white-space: normal !important;
        height: auto !important;
      }
    }
  }
}
</style>
